export var textFieldPropSize = ['m', 'xs', 's', 'l'];
export var textFieldPropSizeDefault = textFieldPropSize[0];
export var textFieldPropView = ['default', 'clear'];
export var textFieldPropViewDefault = textFieldPropView[0];
export var textFieldPropForm = [
    'default',
    'defaultClear',
    'defaultBrick',
    'brick',
    'brickDefault',
    'brickClear',
    'brickRound',
    'round',
    'roundClear',
    'roundBrick',
    'clearRound',
    'clearDefault',
    'clearBrick',
    'clearClear',
];
export var textFieldPropFormDefault = textFieldPropForm[0];
export var textFieldPropStatus = ['alert', 'success', 'warning'];
export var textFieldPropWidth = ['default', 'full'];
export var textFieldPropWidthDefault = textFieldPropWidth[0];
export var sizeMap = {
    xs: 'xs',
    s: 's',
    m: 's',
    l: 'm'
};
export var getValueByStepArray = function (params) {
    var value = params.value, steps = params.steps, min = params.min, _a = params.isIncrement, isIncrement = _a === void 0 ? false : _a;
    var currentValue = Number(value !== null && value !== void 0 ? value : min);
    var minValue = Number(min);
    if (typeof value !== 'string') {
        return typeof min !== 'undefined' ? minValue : 0;
    }
    if (currentValue < steps[0]) {
        return steps[0];
    }
    if (currentValue > steps[steps.length - 1]) {
        return steps[steps.length - 1];
    }
    if ((!isIncrement && currentValue === steps[0]) ||
        (isIncrement && currentValue === steps[steps.length - 1])) {
        return currentValue;
    }
    for (var i = 0; i < steps.length; i++) {
        if (currentValue === steps[i] || (steps[i] < currentValue && steps[i + 1] > currentValue)) {
            return steps[i + (isIncrement ? 1 : -1)];
        }
    }
    return null;
};
export var getValueByStepNumber = function (params) {
    var _a;
    var value = params.value, step = params.step, isIncrement = params.isIncrement, max = params.max, min = params.min;
    var minValue = Number(min);
    var maxValue = Number(max);
    var currentValue = (typeof value === 'string' ? Number(value) : 0) + Number(step) * (isIncrement ? 1 : -1);
    if (!Number.isNaN(minValue) && currentValue <= minValue) {
        return minValue;
    }
    if (!Number.isNaN(maxValue) && currentValue >= maxValue) {
        return maxValue;
    }
    return Number(currentValue.toFixed(Number((_a = 
    /* Необходимо для того, чтобы избежать ситуации, когда по нажатию
на кнопку прибавляется число с погрешностью.
Здесь мы берем разрядность дробной части шага и ограничиваем
результирующее число этой разрядностью */
    Number(step)
        .toString()
        .split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) || 0));
};
export var getIncrementFlag = function (event) {
    if ((event === null || event === void 0 ? void 0 : event.key) !== 'ArrowUp' && (event === null || event === void 0 ? void 0 : event.key) !== 'ArrowDown') {
        return null;
    }
    return (event === null || event === void 0 ? void 0 : event.key) === 'ArrowUp';
};
